import { render, staticRenderFns } from "./GroupFiles.vue?vue&type=template&id=6318013a&"
import script from "./GroupFiles.vue?vue&type=script&lang=js&"
export * from "./GroupFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports